import { useTranslation } from 'react-i18next';

import { IAAOrganizationSubscriptionOverview } from '../../../../../../../models/interfaces/Subscription/AirAmbulance/AAOrganizationSubscriptionOverview';

import { formatDate } from '../../../../../../../utils/dateHelpers';
import { isPropertyEmpty } from '../../../../../../../utils/propertyHelpers';
import { Status } from '../../../../../../../styledComponents/UI/Status/Status';

import {
  Header,
  Wrapper,
  Title,
  DetailsContainer,
  StyledButton,
  Detail,
  DetailLabel,
  DetailValue,
  DetailBreak,
  DetailValueBold,
  AutoCreatedLabel,
} from '../../../../../../../styledComponents/Overview/OverviewDetails/OverviewDetails';
import { EditableStatus } from '../../../../../../../styledComponents/UI/EditableStatus/EditableStatus';

type AAOverviewDetailsProps = {
  data: IAAOrganizationSubscriptionOverview;
  onRenewClick?: () => void;
  canBeRenewed?: boolean;
  canRenewMembershipPermissions?: string[];
  onEditRenewalStatus?: () => void;
};

const AAOverviewDetails = ({
  data,
  onRenewClick,
  canBeRenewed,
  canRenewMembershipPermissions,
  onEditRenewalStatus,
}: AAOverviewDetailsProps) => {
  const { t } = useTranslation();

  return (
    <Wrapper>
      <Header>
        <Title>{t('headers.details')}</Title>
        {onRenewClick && (
          <StyledButton
            permissions={canRenewMembershipPermissions}
            styleType="link"
            onClick={onRenewClick}
            disabled={!isPropertyEmpty(canBeRenewed) ? !canBeRenewed : false}
          >
            {t('buttons.renew')}
          </StyledButton>
        )}
      </Header>
      <DetailsContainer>
        <Detail>
          <DetailLabel>{`${t('properties.status')}:`}</DetailLabel>
          <DetailValue>
            {data && (
              <Status status={data.status} enumName="subscription-status" />
            )}
          </DetailValue>
          {data?.isAutoRenewed && <AutoCreatedLabel />}
        </Detail>
        <DetailBreak />
        <Detail>
          <DetailLabel>{`${t('properties.effective-date')}:`}</DetailLabel>
          <DetailValue>
            {data && formatDate(data.effectiveDateFrom)}
          </DetailValue>
        </Detail>
        <Detail>
          <DetailLabel>{`${t('properties.expiration-date')}:`} </DetailLabel>
          <DetailValue>{data && formatDate(data.effectiveDateTo)}</DetailValue>
        </Detail>
        {data && data.organizationContractName && (
          <Detail>
            <DetailLabel>{`${t('properties.relatedContract')}:`} </DetailLabel>
            <DetailValueBold>
              {data &&
                `${data.organizationContractName} - ${t(
                  `enums.contract-type-shortcut.${data.organizationContractType}`,
                )}`}
            </DetailValueBold>
          </Detail>
        )}
        <Detail>
          <DetailLabel>{`${t('properties.renewalStatus')}:`}</DetailLabel>
          <EditableStatus
            enumName="renewal-status"
            status={data?.renewalStatus}
            onClick={onEditRenewalStatus}
          />
        </Detail>
      </DetailsContainer>
    </Wrapper>
  );
};
export default AAOverviewDetails;
